import { MfaMethod } from '@/generated/graphql';
import { passkeysSupported } from '@/utils/passkeys';

/** The button that switches to each method. */
export const MFA_METHOD_SWITCH_LABELS: Record<MfaMethod, string> = {
  [MfaMethod.Webauthn]: 'Use a passkey',
  [MfaMethod.Totp]: 'Use authenticator app',
  [MfaMethod.RecoveryCode]: 'Use a recovery code',
};

/**
 * The methods this browser can offer, in the API's order (a passkey first).
 * Without `methods` (an older API) it offers an app and recovery codes.
 */
export function usableMfaMethods(methods?: MfaMethod[] | null): MfaMethod[] {
  const listed = methods?.length
    ? methods
    : [MfaMethod.Totp, MfaMethod.RecoveryCode];

  return listed.filter(
    (method) =>
      method in MFA_METHOD_SWITCH_LABELS &&
      (method !== MfaMethod.Webauthn || passkeysSupported()),
  );
}
